import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';

import ErrorBoundary from "./ErrorBoundary";
import CoverConfigurator from './Components/CoverConfigurator';
import Media from './Interfaces/MediaInterface';
import ModelInterface from './Interfaces/ModelInterface';

declare global {
    interface Window {
        sectionId: string,
        configuratorMetaobject: any;
        shapes: any;
        howToMeasure: any;
        lengthHelp: any;
        currencySymbol: string;
        dateHash: string,
        dateSeconds: string,
        selectedConfiguratorModel: ModelInterface | null,
        watermark: Media,
        routes: {
            cart_add_url: string,
            cart_url: string
        }
    }
}

const renderConfigurator = () => {
    const domNode = document.getElementById('cover-configurator');
    if (domNode) {
        const root = createRoot(domNode);
        root.render(
            <StrictMode>
                <ErrorBoundary>
                    <CoverConfigurator 
                        metaobject={window.configuratorMetaobject}
                        shapes={window.shapes}
                    />
                </ErrorBoundary>
            </StrictMode>
        );
    }
}

renderConfigurator();
